module.exports = __webpack_public_path__ + "img/ground-pebbles.be570c43.png";